/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { DirectDebitMandateAcceptanceStatusResponse, DirectDebitMandateInfo } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class DirectDebitMandateController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags direct-debit-mandate-controller
   * @name GetMandateAcceptanceResponse
   * @request GET:/api/v1/mandates/by-organisation/{organisationId}/users/{userId}/acceptance-status
   */
  getMandateAcceptanceResponse = (
    organisationId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<DirectDebitMandateAcceptanceStatusResponse, any>({
      path: `/v1/mandates/by-organisation/${organisationId}/users/${userId}/acceptance-status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMandateAcceptanceResponsePath =
    '/v1/mandates/by-organisation/${organisationId}/users/${userId}/acceptance-status'
  static getMandateAcceptanceResponseMethod = 'GET'
  /**
   * No description
   *
   * @tags direct-debit-mandate-controller
   * @name GetDirectDebitMandateInfoByOrganisationId
   * @request GET:/api/v1/mandates/by-organisation/{organisationId}/consents/mandate-info
   */
  getDirectDebitMandateInfoByOrganisationId = (
    organisationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<DirectDebitMandateInfo, any>({
      path: `/v1/mandates/by-organisation/${organisationId}/consents/mandate-info`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDirectDebitMandateInfoByOrganisationIdPath =
    '/v1/mandates/by-organisation/${organisationId}/consents/mandate-info'
  static getDirectDebitMandateInfoByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags direct-debit-mandate-controller
   * @name GetDirectDebitMandateInfoByApplicationId
   * @request GET:/api/v1/mandates/by-application/consents/mandate-info
   */
  getDirectDebitMandateInfoByApplicationId = (params: RequestParams = {}) =>
    this.http.request<DirectDebitMandateInfo, any>({
      path: `/v1/mandates/by-application/consents/mandate-info`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDirectDebitMandateInfoByApplicationIdPath =
    '/v1/mandates/by-application/consents/mandate-info'
  static getDirectDebitMandateInfoByApplicationIdMethod = 'GET'
}
